<template>
  <div class="grid-view">
    <div
      class="main-content"
      type="primary"
    >
      <search-item
        config-module="410015201"
        :reset="true"
        :custom-sim-query-placeholder="$t('Message.QuickSearchBusinessNo')"
        :auto-init="searchItemAutoInit"
        :custom-search-items="customSearchItems"
        no="1"
        @click-more="value=>isAdvancedQuery=value"
        @simSearchItemCallBack="toSimpleQuery"
        @advSearchItemCallBack="toAdvancedQuery"
      >
        <div slot="operations">
          <el-button v-show="$checkPermission(['button_BillOverseasSCenter_Submit'])" type="primary" no="2" @click="toSubmit()">{{ $t('CargoMsg.Cargo_Submit') }}</el-button>
          <el-button type="primary" no="3" @click="onPrint()">{{ $t('CargoMsg.Cargo_Print') }}</el-button>
          <el-upload
            v-show="$checkPermission(['button_BillOverseasSCenter_importAndQuery'])"
            :action="URL.act.billing.importAndQueryBilling"
            :headers="{sessionId}"
            :show-file-list="false"
            accept=".xls, .xlsx"
            :on-success="importSuccess"
            style="display: inline-block; margin-left: 5px"
            no="4"
          >
            <el-button no="5" type="primary">{{ $t('CargoMsg.Cargo_ImportAndQueryOfBillNumber') }}</el-button>
          </el-upload>
        </div>
      </search-item>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="410015201"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="410015201"
          :total="filter.total"
          :page.sync="filter.pageNum"
          :limit.sync="filter.pageSize"
          @pagination="toQuery"
        />
      </div>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-select-dialog
      :visible.sync="templateSelectorDialog.visible"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :ctx="templateSelectorDialog.ctx"
    />
  </div>
</template>

<script>
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import QueryBillOverseaCondition
  from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/query/queryBillOverseaCondition'
import { getLoading } from '@/utils/utilBaseElement'
import AmountSumMaster from '@/views/cargo/v0/Clearing/components/FinanceChargeSearch/AmountSumMaster'
import BillOverseasSCenterGrid from '@/views/cargo/v0/Clearing/BillOverseasSCenter/components/grid/billOverseasSCenterGrid'
import { queryBillOverseasAdv, batchUpdateStates } from '@/api/clearing/billingNative'
import StrUtils from '@/utils/StrUtils'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { ClearingUtils } from '@/class/cargo/model/utils/ClearingUtils'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
import AdvancedSearchField from '@/class/cargo/model/parameters/AdvancedSearchField'
import { getBankAccountList } from '@/api/bankAccount'
import * as BillingConstants from '@/class/cargo/model/parameters/BillingConstants'
import URL from '@/api/urlTranslator'
import CargoTemplateSelectDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import { recordSelectedStatus } from '@/utils/agGrid'

export default {
  name: 'NewBillOverseasSCenterView',
  components: { BillOverseasSCenterGrid, AmountSumMaster, QueryBillOverseaCondition, searchItem, CargoTemplateSelectDialog },
  data() {
    return {
      gridParams: {},
      columnDefs: [
        {
          headerName: ' ', maxWidth: 40, checkboxSelection: true, pinned: 'left',
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_BillNo'), field: 'billingNo', colId: 'billingNo', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_CounterpartySBillingNo'), colId: 'counterPartyBillingNo', field: 'counterPartyBillingNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_BusinessNoInBill'), colId: 'jobNo', field: 'jobNo'
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Operation'), colId: 'jobOp', field: 'jobOp',
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AccountStatementNo'), colId: 'billingGroupBillingNo', field: 'billingGroupBillingNo'
        },
        { headerName: this.$t('CargoMsg.Cargo_SettleAccountsTo'), field: 'accountId', colId: 'accountId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_SettlementAgent'), field: 'settlementAgentId', colId: 'settlementAgentId', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          } },
        { headerName: this.$t('CargoMsg.Cargo_BillDate'), field: 'inputDate', colId: 'inputDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: 'MBL', field: 'jobMbl', colId: 'jobMbl', width: 200 },
        { headerName: 'ETD', field: 'jobEtd', colId: 'jobEtd', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ETA', field: 'jobEta', colId: 'jobEta', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ATD', field: 'jobAtd', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: 'ATA', field: 'jobAta', width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_BusinessDate'), field: 'jobBusinessDate', colId: 'jobBusinessDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_ItemNo'), field: 'jobPono', colId: 'jobPono', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_CreditAmount2'), field: 'amountCredit', colId: 'amountCredit', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'red' }
            }
            return {}
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_DebitAmount2'), field: 'amountDebit', colId: 'amountDebit', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'blue' }
            }
            return {}
          } },
        { headerName: this.$t('CargoMsg.Cargo_CreditNotWrittenOff'), field: 'amountCreditUnverify', colId: 'amountCreditUnverify', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'red' }
            }
            return {}
          } },
        { headerName: this.$t('CargoMsg.Cargo_DebitNotWrittenOff'), field: 'amountDebitUnverify', colId: 'amountDebitUnverify', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.numberPrecision(params.value)
          },
          cellStyle: (params) => {
            if (!params.data.isAr) {
              return { 'color': 'blue' }
            }
            return {}
          } },
        { headerName: this.$t('CargoMsg.Cargo_Currency'), field: 'currency', colId: 'currency', width: 200 },
        { headerName: this.$t('CargoMsg.Cargo_FinancialDate'), field: 'financialDate', colId: 'financialDate', width: 200,
          valueFormatter: (params) => {
            return this.bussDateLabFun(params)
          } },
        { headerName: this.$t('CargoMsg.Cargo_WriteOffStatus'), field: 'realClearingState', colId: 'realClearingState', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.clearingStateLabFun(params.value)
          } },
        { headerName: this.$t('CargoMsg.Cargo_BillStatus'), field: 'state', colId: 'state', width: 200,
          valueFormatter: (params) => {
            return ClearingUtils.getBillState(Number(params.value))
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Remarks'), field: 'remark', colId: 'remark', width: 200 },
        {
          headerName: this.$t('CargoMsg.Cargo_OurBank'),
          field: 'bankAccountChineseName',
          colId: 'bankAccountChineseName',
          width: 200
        }
      ],
      isAdvancedQuery: false, // 是否为高级查询
      fullscreenLoading: null,
      rowData: [],
      numAll: 100,
      numSelected: 0,
      sumCredit: '',
      sumDebit: '',
      selectedRows: [],
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 100
      },
      filterJson: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowDoubleClicked: this.onRowDoubleClicked,
        onRowClicked: this.onGridRowClickedEvent,
        onSelectionChanged: (event) => {
          this.selectedRows = event.api.getSelectedRows()
          this.caculateAmount()
        }
      },
      customSearchItems: [], // 自定义高级查询项
      searchItemAutoInit: true,
      URL,
      // 模板选择弹窗
      templateSelectorDialog: {
        visible: false,
        category: 'BILLING',
        data: {},
        ctx: null,
        printedCallback: null
      }
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    }
  },
  async created() {
    await this.initCustomSearchItems()
  },
  methods: {
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    toAdvancedQuery(data) {
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      const condition = AdvancedSearchOption.getOption('merge', this.filterJson.conditions)
      if (condition && condition.value && !AdvancedSearchOption.hasField('billing.ACCOUNTID', this.filterJson.conditions)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectBillingParty'))
        return
      }
      if (!AdvancedSearchOption.hasField('billing.STATE', this.filterJson.conditions)) {
        const option = new AdvancedSearchOption('FIELD_DROP_DOWN_LIST', 'billing.STATE', BillingConstants.BILLING_INVOICED.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        this.filterJson.conditions.push(option.formatObj2Json())
      }
      this.filterJson.isAdvancedQuery = true
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryBillOverseasAdv(this.filterJson).then(res => {
        this.handleQueryData(res)
      }).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    toSimpleQuery(data) {
      if (typeof data !== 'undefined') {
        this.filter.jobNo = data
        this.filter.pageNum = 1
      }
      this.filter.conditions = []
      if (!AdvancedSearchOption.hasField('billing.STATE', this.filter.conditions)) {
        const option = new AdvancedSearchOption('FIELD_DROP_DOWN_LIST', 'billing.STATE', BillingConstants.BILLING_INVOICED.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        this.filter.conditions.push(option.formatObj2Json())
      }
      this.filter.isAdvancedQuery = false
      this.filter.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryBillOverseasAdv(this.filter).then((res) => this.handleQueryData(res)).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    handleQueryData(res) {
      const selectedStatus = recordSelectedStatus(this.gridOptions.api, 'uuid')
      this.rowData = []
      for (const data of res.data.list) {
        if (data) {
          this.rowData.push(data)
        }
      }
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.loadingEnd()
      selectedStatus.revert()
    },
    importSuccess(res) {
      if (res.data.length === 0) {
        this.$message.success(this.$t('CargoMsg.noRowsToShow'))
        return
      }
      const option = new AdvancedSearchOption('FIELD_MULTI_TEXT', 'billing.BILLINGNO', res.data, AdvancedSearchConsts.OPERATOR_BATCH.code).formatObj2Json()
      const data = []
      data.push(option)
      if (typeof data !== 'undefined') {
        // 高级查询条件组装
        this.filterJson.conditions = data
        this.filter.pageNum = 1
      }
      const condition = AdvancedSearchOption.getOption('merge', this.filterJson.conditions)
      if (condition && condition.value && !AdvancedSearchOption.hasField('billing.ACCOUNTID', this.filterJson.conditions)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterCorrectBillingParty'))
        return
      }
      if (!AdvancedSearchOption.hasField('billing.STATE', this.filterJson.conditions)) {
        const option = new AdvancedSearchOption('FIELD_DROP_DOWN_LIST', 'billing.STATE', BillingConstants.BILLING_INVOICED.code, AdvancedSearchConsts.OPERATOR_EQUAL.code)
        this.filterJson.conditions.push(option.formatObj2Json())
      }
      this.filterJson.isAdvancedQuery = true
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.fullscreenLoading = getLoading()
      queryBillOverseasAdv(this.filterJson).then(result => {
        if (result.data.list.length === 0) {
          this.$message.success(this.$t('CargoMsg.noRowsToShow'))
          return
        }
        this.handleQueryData(result)
      }).finally(() => {
        this.fullscreenLoading.close()
      })
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.fullscreenLoading.close()
      this.selectedRows = []
      this.caculateAmount()
    },
    toSubmit() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      for (const billing of selectRows) {
        if (StrUtils.isEmpty(billing.billingNo)) {
          this.$message.warning(this.$t('CargoMsg.Cargo_OnlyBillsWithBillingNumbersCanBeSubmitted'))
          return
        }
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureDoThis'), this.$t('Pricing.Tips'), {
        confirmButtonText: this.$t('common.btn.yes'),
        cancelButtonText: this.$t('common.btn.no'),
        type: 'warning'
      }).then(() => {
        if (this.checkSubmitBilling()) {
          // 退回到已打印状态
          this.fullscreenLoading = getLoading()
          batchUpdateStates(selectRows, { state: 4 }).then(res => {
            this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
            this.gridOptions.api.updateRowData({ 'remove': selectRows })
            this.loadingEnd()
          }).catch(() => {
            this.fullscreenLoading.close()
          })
        }
      })
    },
    checkSubmitBilling() {
      for (const bill of this.selectedRows) {
        if (bill.state === 4 || bill.state === 5) {
          this.$message.warning(StrUtils.substitute(this.$t('CargoMsg.Cargo_BillHasBeenSubmitted'), bill.billingNo))
          return false
        }
      }
      return true
    },
    caculateAmount() {
      let credit = 0
      let debit = 0
      for (const cg of this.selectedRows) {
        if (cg.ar) { debit += cg.amount } else { credit += cg.amount }
      }
      this.sumCredit = credit.toFixed(2)
      this.sumDebit = debit.toFixed(2)
    },
    bussDateLabFun(params) {
      const bill = params.data
      if (!bill || !bill.charge) { return '' }
      if (bill.charge.length > 0) {
        return ColumnUtils.dateLabelFunc(bill.charge[0].accountingDate)
      }
      return ''
    },
    async initCustomSearchItems() {
      const defaultSearchFields = []
      // 银行名称和银行账号要去重
      const bankList = []
      const res = await getBankAccountList(this.$store.getters.currentOfficeUuid)
      if (res.data && res.data.length > 0) {
        for (const item of res.data) {
          bankList.push(item)
        }
      }
      // 我方银行名称
      const searchField = new AdvancedSearchField()
      searchField.itemType = 'advanceSelect'
      searchField.multiple = 0
      searchField.action = 2
      searchField.fieldType = 'FIELD_DROP_DOWN_LIST'
      searchField.itemValue = []
      searchField.itemLabel = 'CargoMsg.Cargo_OurBank'
      searchField.itemName = 'billing.BANK_ACCOUNT_ID'
      searchField.headers = [this.$t('Clearing.BankName')]
      searchField.fields = ['bankChineseName']
      searchField.tagName = 'bankChineseName'
      searchField.tagValue = 'accountId'
      searchField.dataCacheKey = 'static_data_BankAccount'
      searchField.dataProvider = bankList
      defaultSearchFields.push(searchField.formatObj2Json())
      if (defaultSearchFields.length > 0) {
        this.customSearchItems.push(...defaultSearchFields)
        this.searchItemAutoInit = true
      }
    },
    onPrint() {
      const selectRows = this.selectedRows
      if (!selectRows || selectRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectBill'))
        return
      }
      const keyList = []
      for (const billing of selectRows) {
        keyList.push(billing.key)
      }
      const params = {
        BILLING_UUID_LIST: keyList,
        BILLING_UUID: keyList
      }
      // CARGO-6000，圣世特：V2模板，国内账单另存文件，文件名需要由模板名称+账单号组成
      if (selectRows.length === 1) {
        params['billingNo'] = selectRows[0].billingNo
        if (!StrUtils.isEmpty(selectRows[0].jobNo)) {
          params['jobNo'] = selectRows[0].jobNo
        }
      }
      this.templateSelectorDialog.visible = true
      this.templateSelectorDialog.ctx = null
      this.templateSelectorDialog.data = params
    }
  }
}
</script>

<style lang="scss">
.bill-overseas-s-center-view{
  .totalLabel{
    margin-top: 6px;
    margin-left: 10px;
    margin-right: 10px;
  }
}
</style>
